// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sfoai","question":"styles_question__3SCd7","inputVisibleButton":"styles_inputVisibleButton__XZzFd","note":"styles_note__2riO3"};